import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Login from "./pages/login/Login";
import ForgotPassword from "./pages/forgotpassword/ForgotPassword";
import Home from "./pages/home/home";
import { loginSuccess } from "./redux/slices/userSlice";

const App = () => {
  const dispatch = useDispatch();
  const isLoggedIn = useSelector((state) => state.user.isLoggedIn);

  useEffect(() => {
    const token = localStorage.getItem("token");
    const user = JSON?.parse(localStorage.getItem("user"));
    console.log(token);
    console.log(user);

    if (token && user) {
      dispatch(loginSuccess({ user, token }));
    }
  }, [dispatch]);

  return (
    <Router>
      <Routes>
        {/* If the user is logged in, redirect to home page */}
        <Route
          path="/"
          element={isLoggedIn ? <Navigate to="/home" /> : <Login />}
        />

        {/* Public route for Forgot Password */}
        <Route path="/forgotpassword" element={<ForgotPassword />} />

        {/* Protected Route for Home - only accessible when logged in */}
        <Route
          path="/home"
          element={isLoggedIn ? <Home /> : <Navigate to="/" />}
        />

        {/* Catch-all route: if the user is not logged in, they can't access any page except login */}
        <Route
          path="*"
          element={isLoggedIn ? <Navigate to="/home" /> : <Navigate to="/" />}
        />
      </Routes>
    </Router>
  );
};

export default App;
